/**
 * Exported so the browser enforces the same numbers the wire contract does. The report carries
 * storage references, never bytes: `/api/*` caps bodies at 100 KB, so images go via the upload
 * endpoint instead.
 */
export const ISSUE_REPORT_ATTACHMENT_LIMITS = {
  filename: 255,
  /**
   * Product cap. Server-side each file costs two sequential upstream round trips (a storage read
   * and a provider upload), so raising this raises the worst-case request latency linearly.
   */
  count: 5,
  /** Jira's own attachment cap; checked server-side after the storage read, so it bounds what is attached, not what is downloaded. */
  maxBytes: 10 * 1024 * 1024,
} as const;

/**
 * Enforced server-side too: `accept` is a convenience, and storage keeps whatever type was claimed.
 * Must stay a subset of `ALLOWED_MIME_TYPES` in `shared/nodejs` — the upload endpoint rejects
 * anything else, so a type offered here but missing there is a 400 the reporter only sees after
 * picking the file. Guarded by `issueReportAttachmentContentTypes.spec.ts`.
 */
export const ISSUE_REPORT_ATTACHMENT_CONTENT_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp',
] as const;
